$(document).ready(function(){

// home-page slider
  
 $('.ctm_slider').slick({
   dots: false,
   infinite: true,
   autoplay : true,
   speed: 1000,
   slidesToShow: 5,
   slidesToScroll: 1,
   responsive: [
     {
       breakpoint: 1024,
       settings: {
         slidesToShow: 4,
         slidesToScroll: 1,
         infinite: true,
         dots: false
       }
     },
     {
       breakpoint: 600,
       settings: {
         slidesToShow: 3,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 480,
       settings: {
         slidesToShow: 1,
         slidesToScroll: 1
       }
     }
   ]
});


//  about-page-accordion
   $(".tab_sub_txt").click(function(){
    $(this).closest('.tab_qt_tb').find(".tab_qt_ans").slideToggle();
    $(this).closest('.tab_qt_tb').find(".plus_icon").toggleClass("minus");
    $(this).closest('.tab_qt_tb').find(".minus_icon").toggleClass("plus");
  });

  
// header-mega-menu
  $(document).on("click", ".ctm_mega_menu-list", function(){
     $(this).find(".ctm_mega_menu-child").toggleClass("active");
     $(this).find("a.header__menu-item").toggleClass("open");
  }); 

// prodct-weight

// $(".product-form__controls-group input").click(function(){
//     // alert("yes");
//   var data = $(this).attr("weight-data");
//     console.log(data);
//   $(".product_weight span.ctm_product_weight").html(data);
// });
  
  
});


// Cooler Remove 


